enum liens {
	login = '/auth/login',
	token = '/auth/token',
	validate = '/auth/validate',
	listeProcedure = '/procedures/liste',
	creationProcedure = '/procedure/creation',
	detailProcedure = '/procedure/detail',
	uuidApi = '/api/procedure/uuid',
	ajoutFichierApi = '/api/procedure/addFile',
	suppressionFichierApi = '/api/procedure/removeFile',
	creerProcedureApi = '/api/procedure/create',
	annulerProcedureApi = '/api/procedure/cancel',
	telechargementFichierApi = '/api/procedure/getFile',
	telechargementPreuveApi = '/api/procedure/getProofFile',
	listeUtilisateuroktaApi = '/api/okta/user',
	listeProcedureApi = '/api/procedures/list',
	listeContactApi = '/api/contacts/list'
}

export default liens